module.exports = __webpack_public_path__ + "img/40_37_013_000.5e3b75f3.jpg";